/**
 * Share button custom element for product page.
 * Uses native Web Share API when available; otherwise shows a details dropdown with copy link.
 */
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');
        this.nativeButton = this.querySelector('.share-button__native');
        this.urlInput = this.querySelector('[data-share-url-input]');
        this.messageEl = this.querySelector('[data-share-message]');
        this.closeButton = this.querySelector('[data-share-close]');
        this.copyButton = this.querySelector('[data-share-copy]');
        this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href;
      }

      connectedCallback() {
        if (navigator.share) {
          this.details?.setAttribute('hidden', '');
          this.nativeButton?.classList.remove('hidden');
          this.nativeButton?.addEventListener('click', () => this.handleNativeShare());
        } else {
          this.details?.addEventListener('toggle', () => this.onDetailsToggle());
          this.copyButton?.addEventListener('click', () => this.copyToClipboard());
          this.closeButton?.addEventListener('click', () => this.close());
        }
      }

      handleNativeShare() {
        navigator
          .share({
            url: this.urlToShare,
            title: document.title,
          })
          .catch(() => {});
      }

      onDetailsToggle() {
        if (!this.details?.open) {
          this.messageEl?.classList.add('hidden');
          if (this.messageEl) this.messageEl.textContent = '';
          this.closeButton?.classList.add('hidden');
          this.details?.querySelector('summary')?.focus();
        }
      }

      copyToClipboard() {
        if (!this.urlInput) return;
        navigator.clipboard.writeText(this.urlInput.value).then(() => {
          const message = this.dataset.shareSuccess || 'Link copied to clipboard';
          this.messageEl?.classList.remove('hidden');
          if (this.messageEl) this.messageEl.textContent = message;
          this.closeButton?.classList.remove('hidden');
          this.closeButton?.focus();
        });
      }

      close() {
        this.details?.removeAttribute('open');
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.urlInput) this.urlInput.value = url;
      }
    }
  );
}
